import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import DefaultPageContext from '../../../../../context/DefaultPageContext';
import DataTableContext from "../../../../../context/DataTableContext";

export const CheckboxData = (props) => {
  const pageContext = useContext(DefaultPageContext);
  const tableContext = useContext(DataTableContext);
  const datasource = tableContext.datasource.data ? tableContext.datasource.data.map(ds => ds.attributes) : [];
  const { auxKey, data, dataKey, isHeader, style } = props;

  const onHeaderClick = () => {
    const currentValue = !tableContext.selectAllChecked;
    
    if (currentValue) {
      pageContext.setSelectedItems(datasource);
    } else {
      pageContext.setSelectedItems([]);
    }

    tableContext.toggleSelectAll();
  };

  const onBodyClick = () => {
    const selectedIds = pageContext.selectedItems.map(item => auxKey ? `${item.id}#${item[auxKey]}` : item.id);
    const id = auxKey ? `${data[dataKey]}#${data[auxKey]}` : data[dataKey];

    if(selectedIds.indexOf(id) > -1) {
      const itemFilter = (item) => auxKey ? `${item.id}#${item[auxKey]}` !== id : item.id !== id;
      pageContext.setSelectedItems(pageContext.selectedItems.filter(itemFilter));
    }else {
      const itemFind = (ds) => auxKey ? `${ds.id}#${ds[auxKey]}` === id : ds.id === id;
      const item = datasource.find(itemFind);
      item ? pageContext.setSelectedItems(pageContext.selectedItems.concat(item)) : null;
    }
  };

  const TableHeader = () => {
    return(
      <th style={style}>
        <input
          onChange={onHeaderClick}
          type="checkbox"
          checked={tableContext.selectAllChecked} />
      </th>
    );
  };

  const TableData = () => {
    return(
      <td style={style}>
        <input
          type="checkbox"
          checked={!!pageContext.selectedItems.find((item) => item.id === data[dataKey])}
          onChange={onBodyClick} />
      </td>
    );
  };


  return isHeader ? <TableHeader /> : <TableData />;
};

CheckboxData.defaultProps = {
  isHeader: false,
  style: { width: '5%', minWidth: '3%', textAlign: 'center' }
};

CheckboxData.propTypes = {
  data: PropTypes.object.isRequired,
  dataKey: PropTypes.string.isRequired
};